<section class="stats-section">

  <!-- Background decorative orbs -->
  <div class="stats-bg" aria-hidden="true">
    <div class="stats-orb stats-orb--1"></div>
    <div class="stats-orb stats-orb--2"></div>
  </div>

  <div class="container">

    <div class="stats-eyebrow">
      <span class="eyebrow-line"></span>
      <span class="eyebrow-text">{{'MM_MoreThan' | translate}}</span>
      <span class="eyebrow-line"></span>
    </div>

    <div class="stats-grid">
      <div class="stat-item" *ngFor="let item of statistics">
        <div class="stat-number" [innerHTML]="item.counterNumber | translate"></div>
        <div class="stat-label" [innerHTML]="item.description | translate"></div>
      </div>
    </div>

  </div>
</section>
